export const SOFTLINE_API_CONTENT = '/v1/document/text';
